import Vue from 'vue';
import VueRouter from 'vue-router';
import Profile from '@/views/Profile.vue';
import ChangePassword from '@/views/ChangePassword.vue';
import Unsubscribe from '@/views/Unsubscribe.vue';
import Login from '@/views/Login.vue';
import UpdatedHome from '@/views/UpdatedHome.vue'
import Logout from '@/views/Logout.vue';
import Register from '@/views/Register.vue';
import ForgottenPassword from '@/views/ForgottenPassword.vue';
import AddSubscription from '@/views/AddSubscription.vue';
import SevaMedia from '@/views/publishers/SevaMedia.vue';
import Intermarche from '@/views/publishers/Intermarche.vue';
import Hub from '@/views/Hub.vue';
import SubscribeV2 from "@/views/SubscribeV2.vue";
import PricingPopup from "@/components/PricingPopup.vue"
import store from '@/store/index';
import {UserOrigin, hasUtmParams, initUTMTracking} from '@/utils/analytics';

const APP_TV = process.env.VUE_APP_WEB_APP_URL;
const APP_STORIES = process.env.VUE_APP_STORIES_APP_URL;
const APP_GAMES = process.env.VUE_APP_GAMES_APP_URL;

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    path: '/:locale',
    component: {
        render: h => h('router-view')
    },
    routes: [
        {
            path: '/',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/change-password',
            name: 'change-password',
            component: ChangePassword
        },
        {
            path: '/unsubscribe/:id',
            name: 'unsubscribe',
            component: Unsubscribe
        },
        {
            path: '/unsubscribe/:id?',
            name: 'unsubscribe',
            component: Unsubscribe
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout
        },
        {
            path: '/register/:partner?',
            name: 'register',
            component: Register
        },
        {
            path: '/register/:email?',
            name: 'register',
            component: Register
        },
        {
            path: '/swisscom',
            name: 'swisscom',
            component: Register
        },
        {
            path: '/intermarche',
            name: 'intermarche',
            component: Intermarche
        },
        {
            path: '/ACEF',
            name: 'intermarche',
            component: Intermarche
        },
        {
            path: `${encodeURI('/intermarché')}`,
            name: 'intermarche-alt',
            component: Intermarche
        },
        {
            path: '/subscribe',
            name: 'subscribe',
            component: SubscribeV2
        },
        {
            path: '/products',
            name: 'products',
            component: Hub,
        },
        {
            path: '/forgotten-password',
            name: 'forgotten-password',
            component: ForgottenPassword
        },
        {
            path: '/add-subscription',
            name: 'add-subscription',
            component: AddSubscription
        },
        {
            path: '/resubscribe',
            name: 'resubscribe',
            component: SubscribeV2
        },
        {
            path: '/coupon',
            name: 'publisher-sevamedia',
            component: SevaMedia,
        },
        {
            path: '/changeSubscriptionPlan',
            name: 'changeSubscriptionPlan',
            component: PricingPopup
        },
        {
            path: '/changePlan',
            name: 'changePlan',
            component: SubscribeV2
        },
        {
            path: '/changePlan/:key?',
            name: 'changePlan',
            component: SubscribeV2
        },
        {
            path: '/promo/:code?',
            name: 'promo',
            component: Register
        },
        {
            path: '/homePage',
            name: 'homePage',
            component: UpdatedHome
        },
        // Deep Link Redirection Routes (NEW)
        {
            path: '/apps/tv',
            name: 'app-tv',
            beforeEnter: (to, from, next) => {
                window.location.href = APP_TV;
            }
        },
        {
            path: '/apps/stories',
            name: 'app-stories',
            beforeEnter: (to, from, next) => {
                window.location.href = APP_STORIES;
            }
        },
        {
            path: '/apps/games',
            name: 'app-games',
            beforeEnter: (to, from, next) => {
                window.location.href = APP_GAMES;
            }
        },
        {
            path: '/partners/twt-partner',
            redirect: '/homePage'
        },
        {
            path: '/partners/tclpromo',
            redirect: '/homePage'
        },
        {
            path: '/partners/orange-link',
            redirect: '/homePage'
        },
        {
            path: '/partners/vodafone_account',
            redirect: '/homePage'
        },
        {
            path: '/partners/cafeyn',
            redirect: '/homePage'
        },

    ]
});
router.afterEach(async (to, from) => {

  if (hasUtmParams(to.query)) {
    store.dispatch('updateUtmData', to.query);
    await store.dispatch('updateUserOrigin', UserOrigin.ADS);
    initUTMTracking();
  }

  if (typeof fbq !== 'function') return;

  const pathEvents = {
    '/homePage': ['ViewContent'],
    '/subscribe': ['AddPaymentInfo'],
  };

  if (pathEvents[to.path]) {
    pathEvents[to.path].forEach(event => fbq('track', event));
  }
});

export default router;
